export default __webpack_public_path__ + "static/media/ic_usdc.e_40.e37c07cc.svg";